// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsentBanner_banner__Qrk9k","message":"CookieConsentBanner_message__W9oDE","actions":"CookieConsentBanner_actions__kZXB+"};